<template>
  <HeaderNav></HeaderNav>
  <HomePage></HomePage>
  <FooterNav class="fixed bottom-0"></FooterNav>
</template>
<script>
import HomePage from "@/components/HomePage.vue";
import HeaderNav from "@/components/reusable/HeaderNav.vue";
import FooterNav from "@/components/reusable/FooterNav.vue";

export default {
  name: "HomePageView",
  components: {
    HomePage,
    HeaderNav,
    FooterNav,
  },
};
</script>
